// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `motes-toast {
  position: fixed;
  top: 5px;
  left: 0;
  width: 100%;
  z-index: 40;
  pointer-events: none;
}
motes-toast .container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  transform: translateY(-120%);
  transition: 0.3s transform;
}
motes-toast .container.show {
  transform: translateY(0%);
}
motes-toast .toast {
  display: flex;
  padding: var(--large-spacing);
  box-sizing: border-box;
  border-radius: var(--border-radius);
  white-space: nowrap;
  align-items: center;
  background-color: var(--motes-white);
  box-shadow: var(--shadow-elevation-medium);
  width: -moz-fit-content;
  width: fit-content;
  min-height: 50px;
  margin: 5px auto;
  pointer-events: auto;
  cursor: default;
}
motes-toast .toast .msg {
  color: var(--motes-black);
  font-size: 16px;
  white-space: pre-wrap;
}
motes-toast .toast .toast-action {
  cursor: pointer;
}
motes-toast .toast span {
  display: flex;
}
motes-toast .toast .type-icon {
  margin-right: var(--motes-padding);
  color: var(--motes-black);
}
motes-toast .toast .type-icon .svg-icon {
  font-size: 25px;
}
motes-toast .toast .type-icon.red {
  color: var(--motes-light-red);
}
motes-toast .toast .type-icon.green {
  color: var(--motes-light-green);
}
motes-toast .toast .close-icon {
  margin-left: var(--motes-padding);
  cursor: pointer;
}
motes-toast .toast .close-icon:hover {
  transform: scale(1.4);
  transition: 0.2s transform;
}
motes-toast .toast .close-icon .svg-icon {
  color: #B3B3B3;
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/toast/toast.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,oBAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,0BAAA;AACR;AACQ;EACI,yBAAA;AACZ;AAGI;EACI,aAAA;EACA,6BAAA;EACA,sBAAA;EACA,mCAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,0CAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AADR;AAGQ;EACI,yBAAA;EACA,eAAA;EACA,qBAAA;AADZ;AAIQ;EACI,eAAA;AAFZ;AAKQ;EACI,aAAA;AAHZ;AAMQ;EACI,kCAAA;EACA,yBAAA;AAJZ;AAMY;EACI,eAAA;AAJhB;AAOY;EACI,6BAAA;AALhB;AAQY;EACI,+BAAA;AANhB;AAUQ;EACI,iCAAA;EACA,eAAA;AARZ;AAUY;EACI,qBAAA;EACA,0BAAA;AARhB;AAWY;EACI,cAAA;EACA,eAAA;AAThB","sourcesContent":["motes-toast {\n    position: fixed;\n    top: 5px;\n    left: 0;\n    width: 100%;\n    z-index: 40; // Root-level toast elements should have z-indices ranging between 40 and 49: https://docs.storyhunt.dk/dev/creator/style-guide.html\n    pointer-events: none;\n\n    .container {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        transform: translateY(-120%);\n        transition: .3s transform;\n\n        &.show {\n            transform: translateY(0%);\n        }\n    }\n\n    .toast {\n        display: flex;\n        padding: var(--large-spacing);\n        box-sizing: border-box;\n        border-radius: var(--border-radius);\n        white-space: nowrap;\n        align-items: center;\n        background-color: var(--motes-white);\n        box-shadow: var(--shadow-elevation-medium);\n        width: fit-content;\n        min-height: 50px;\n        margin: 5px auto;\n        pointer-events: auto;\n        cursor: default;\n\n        .msg {\n            color: var(--motes-black);\n            font-size: 16px;\n            white-space: pre-wrap;\n        }\n\n        .toast-action {\n            cursor: pointer;\n        }\n\n        span {\n            display: flex;\n        }\n\n        .type-icon {\n            margin-right: var(--motes-padding);\n            color: var(--motes-black);\n\n            .svg-icon {\n                font-size: 25px;\n            }\n\n            &.red {\n                color: var(--motes-light-red);\n            }\n\n            &.green {\n                color: var(--motes-light-green);\n            }\n        }\n\n        .close-icon {\n            margin-left: var(--motes-padding);\n            cursor: pointer;\n\n            &:hover {\n                transform: scale(1.4);\n                transition: .2s transform;\n            }\n\n            .svg-icon {\n                color: #B3B3B3;\n                font-size: 10px;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
